// extracted by mini-css-extract-plugin
export var faq = "styles-module--faq--CeyBT";
export var label = "styles-module--label--Y1Z+h";
export var links = "styles-module--links--kK2cK";
export var question = "styles-module--question--CybW0";
export var textContainer = "styles-module--textContainer--orlId";